<section>
  <div class="cert__tab-header">
    <div>
      <p>
        {{ "Cert.PageDescription2" | translate }}
        <a
          href="https://servicedesk.surf.nl/wiki/spaces/WIKI/pages/195871207/DDoS-bescherming"
          target="_blank"
          rel="noopener noreferrer"
        >
          wiki</a
        >.
      </p>
    </div>
  </div>
  <cert-mitigation />
  <cert-security />
  <cert-ddos-line-chart />
</section>
